import HierarchyShowContainer from './hierarchy_show_container';

const HierarchyShow = HierarchyShowContainer;

export default HierarchyShow;
